export const getEnvironment = () => {
    return window.location.host.indexOf('localhost') !== -1
        ? 'localhost'
        : window.location.host.indexOf('orcawebdev') !== -1 || window.location.host.indexOf('dev.orcaweb') !== -1
        ? 'dev'
        : window.location.host.indexOf('orcawebqa') !== -1 || window.location.host.indexOf('qa.orcaweb') !== -1
        ? 'qa'
        : 'prod';
};
